import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { activeTenant } from '@app/tenant';
import { readTenantEnv } from '@app/tenant/env';
import { LightLayout } from '@app/layouts';
import { SignUp } from '@app/auth/components/SignUp';

export const SignUpPage = () => {
  const reCaptchaKey = (activeTenant ? readTenantEnv(activeTenant.slug, 'GOOGLE_RECAPTCHA_KEY') : '') || '';

  return (
    <LightLayout>
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        <SignUp />
      </GoogleReCaptchaProvider>
    </LightLayout>
  );
};
